import Button from '@/Components/Button/Button';
import { Dialog, DialogButtons, DialogContent, DialogTitle } from '@/Components/Dialog/Dialog';
import { useFilingCabinetContext } from '@/Contexts/Authenticated/FilingCabinetContext';
import { type FilingCabinetItem } from '@/Models/FilingCabinet/FilingCabinet';
import { useTranslation } from 'react-i18next';
import * as filingCabinetLocks from '../../Scripts/FilingCabinetLocks';
import Styles from './CloseLockedFilesDialog.module.scss';

export interface CloseLockedFilesDialogProps {
    item: FilingCabinetItem | null;
    isOpen: boolean;
    single: boolean;
    okCb: Function;
    cancelCb: Function;
}

function CloseLockedFilesDialog({ item, isOpen, single, okCb, cancelCb }: Readonly<CloseLockedFilesDialogProps>): React.ReactElement {
    const { t } = useTranslation();
    const { getLockedFiles } = useFilingCabinetContext();

    const onOk = (): void => {
        filingCabinetLocks.setAllowedToClose(true);
        okCb(item);
    };

    return (
        <Dialog open={isOpen} draggable>
            <DialogTitle>{t('Attention')}</DialogTitle>
            <DialogContent>
                <div className={Styles.warning}>
                    <div>{t(single ? 'AreYouSureCloseFile' : 'AreYouSureCloseAllFiles')}</div>
                    <div>{t('ReloadFileInfo2')}</div>
                </div>
                <div>
                    { (isOpen && !single) ? getLockedFiles().map((x: FilingCabinetItem) => <div key={x.ID} className={Styles.fileTitle}>{x.title}</div>) : ''}
                </div>
            </DialogContent>
            <DialogButtons>
                <Button mediumGreen onClick={(_) => onOk()}>{t('Close')}</Button>
                <Button onClick={(_) => cancelCb()}>{t('Cancel')}</Button>
            </DialogButtons>
        </Dialog>
    );
}

export default CloseLockedFilesDialog;
